import { Tooltip } from "@mui/material";
import { ReactNode, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

interface EllipsisTooltipProps {
  children: ReactNode;
  content: string | null;
  placement?:
    | "bottom-start"
    | "bottom-end"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
}

const EllipsisTooltip: React.FC<EllipsisTooltipProps> = ({
  children,
  content,
  placement = "bottom-start",
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const isOverflowing =
      ref.current && ref.current.scrollWidth > ref.current.clientWidth;
    setShowTooltip(!!isOverflowing);
  }, [children]);

  return (
    <div
      ref={ref}
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      }}
    >
      {showTooltip ? (
        <Tooltip title={content} data-private="true" placement={placement}>
          <span data-private="true">{children}</span>
        </Tooltip>
      ) : (
        <span data-private="true">{children}</span>
      )}
    </div>
  );
};

EllipsisTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.string,
  placement: PropTypes.oneOf([
    "bottom-start",
    "bottom-end",
    "bottom",
    "left-end",
    "left-start",
    "left",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top",
  ]),
};
export default EllipsisTooltip;
